import { ResiliationFormulaState } from '../types';

function isPriceSectionComplete(state: ResiliationFormulaState) {
  return !(
    (state.normalPrice === undefined)
    || (state.promotionDuration === undefined)
    || (!!state.promotionDuration && state.promotionPrice === undefined)
  );
}

function isContractSectionComplete(state: ResiliationFormulaState) {
  if (state.contractType === 'mobile') return true;
  if (state.contractType === 'box' && state.operator !== undefined) return true;
  return false;
}

function isCommitmentSectionComplete(state: ResiliationFormulaState) {
  return !(
    state.commitmentDuration === undefined
    || (!!state.commitmentDuration && state.startDate === undefined)
    || (state.commitmentDuration === 24 && state.startDate && state.startDate.getFullYear() >= 2023 && state.hasEquipment === undefined)
  );
}

export default function computeCompletedSteps(state: ResiliationFormulaState) {
  return {
    price: isPriceSectionComplete(state),
    contract: isContractSectionComplete(state),
    commitment: isCommitmentSectionComplete(state),
  };
}
